(function ($) {

    $(function () {
        var bannerSlider = $('.banner .slider');

        // Image slider exists?
        if (bannerSlider.length < 1) {
            return;
        }

        // Append controls
        var controlPrev = '<button class="control control--prev"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" /></svg></button>';
        var controlNext = '<button class="control control--next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" /></svg></button>';
        bannerSlider.find('.controls').prepend(controlPrev);
        bannerSlider.find('.controls').append(controlNext);

        // Remove/add classes
        bannerSlider.removeClass('slider--no-js');

        // Initialise slider/carousel
        var flexContentImageSlider = tns({
            container: '.banner .slider .slides',
            items: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayTimeout: 7000,
            speed: 1000,
            loop: true,
            nav: true,
            navPosition: 'bottom',
            navContainer: '.banner .slider .pagers',
            mouseDrag: false,
            arrowKeys: false,
            touch: true,
            controls: true,
            nextButton: '.banner .slider .controls .control--next',
            prevButton: '.banner .slider .controls .control--prev',
            preventActionWhenRunning: true,
        });
    });

})(jQuery);